<section #bankIdContainer class="protected-identity-bankid-dialog" [class.fullscreen-active]="isFullscreen">
  <header class="protected-identity-bankid-dialog__header">
    <img src="assets/image/bankId.svg" alt="" />
    <h2>{{ 'PROTECTED_IDENTITY.BANKID_TITLE' | translate }}</h2>
  </header>

  @if (!running) {
    <p class="protected-identity-bankid-dialog__introduction">
      {{ 'PROTECTED_IDENTITY.BANKID_INTRODUCTION' | translate }}
    </p>
    <div class="protected-identity-bankid-dialog__actions" [class.mobile-device-prompt]="isMobile">
      <astral-button
        class="protected-identity-bankid-dialog__wide-action"
        type="button"
        [variant]="isMobile ? 'secondary' : 'primary'"
        labelKey="LOGIN_FORM.START_BANKID_OTHER_DEVICE"
        (click)="startBankId(false)"
      ></astral-button>
      <astral-button
        class="protected-identity-bankid-dialog__wide-action"
        type="button"
        [variant]="isMobile ? 'primary' : 'secondary'"
        labelKey="LOGIN_FORM.START_BANKID"
        (click)="startBankId(true)"
      ></astral-button>
    </div>
  } @else {
    <app-bankid-auth
      [isAutoStart]="isAutoStart"
      (requestFullscreen)="toggleFullscreen()"
      (result)="onResult($event)"
    ></app-bankid-auth>
    @if (isVerifying) {
      <div class="protected-identity-bankid-dialog__verifying" role="status">
        <i class="icon-spinner hogia-spin" aria-hidden="true"></i>
        {{ 'PROTECTED_IDENTITY.BANKID_VERIFYING' | translate }}
      </div>
    }
  }

  <div class="protected-identity-bankid-dialog__security-note">
    <i class="fa-light fa-shield-check" aria-hidden="true"></i>
    <span>{{ 'PROTECTED_IDENTITY.BANKID_SECURITY_INFORMATION' | translate }}</span>
  </div>

  <div class="protected-identity-bankid-dialog__footer">
    <astral-button type="button" variant="secondary" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>

  @if (isFullscreen) {
    <astral-button
      class="protected-identity-bankid-dialog__exit-fullscreen"
      type="button"
      variant="secondary"
      icon="clear"
      labelKey="COMMON.EXIT_FULLSCREEN"
      (click)="toggleFullscreen()"
    ></astral-button>
  }
</section>
